import { render, staticRenderFns } from "./dashboard-layout.vue?vue&type=template&id=28a361bf&scoped=true"
import script from "./dashboard-layout.vue?vue&type=script&lang=ts"
export * from "./dashboard-layout.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28a361bf",
  null
  
)

export default component.exports